import React from 'react'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import _ from 'lodash'

//import Analytics from '../classes/analytics'
import Profile from '../classes/profile'
//import { _registerUser } from '../classes/analytics'


/** Thin wrapper around Route that will capture user activity via Segment.io
 *
 */
class AnalyticsRoute extends React.Component {
  static propTypes = {
    profile: Profile.PropTypes,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    computedMatch: PropTypes.object
  }

  // componentDidUpdate (prevProps) {
  //   const profile = new Profile(prevProps.profile)
  //   if (profile.isDefined) {
  //     // console.log("MOUNT: Identify user %o", profile)
  //     _registerUser(profile)
  //   }
  //   if (this._validRoute()) {
  //     // console.log("MOUNT: Fire event %o, %s", this._getMostSpecificRoute(), JSON.stringify(this._getFilteredRouteParams()))
  //     Analytics.page(
  //       this._getMostSpecificRoute(),
  //       this._getFilteredRouteParams()
  //     )
  //   } else {
  //     console.log('Skipping analytings for this', prevProps.computedMatch)
  //   }
  //   // Check if the route has changed
  //   if (this._validRoute() && this.props.location.pathname !== prevProps.location.pathname) {
  //     // console.log("UPDATE: Fire event %o, %s", this._getMostSpecificRoute(), JSON.stringify(this._getFilteredRouteParams()))
  //     Analytics.page(
  //       this._getMostSpecificRoute(),
  //       this._getFilteredRouteParams()
  //     )
  //   }
  // }

  /*
   * Is this a valid route?
   */
  _validRoute () {
    return !!this.props.computedMatch
  }

  /*
   * Find the route that most specifically describes the page we're on without also including
   * specifics like id's.
   *
   * This relies on us being in a Switch route where the computedMatch property is set.
   */
  _getMostSpecificRoute () {
    return this.props.computedMatch.path
  }

  /*
   * Get the route params (object ids mostly), but filtered.
   *
   * The * routes get a parameter called splat which we don't want to pass along.
   */
  _getFilteredRouteParams () {
    const filtered = _.omit(this.props.computedMatch.params, 'splat')
    return (filtered)
  }

  render () {
    const routeProps = _.omit(this.props, ['match', 'location'])
    return (<Route {...routeProps} />)
  }
}

function mapStateToProps (state) {
  const profile = state.user.profile && new Profile(state.user.profile)
  return {
    profile
  }
}

export default connect(mapStateToProps)(withRouter(AnalyticsRoute))
